<template>
  <div>
    <div class="fc-text-center">
    	<img class="paystatus_img" src="../assets/img/successIcon.png">
      <p class="paystatus_title">{{$t('m.PayStatusSuccess_title')}}</p>
      <div class="fc-btn-main backhomepage fc-mar-t-super success-btn" @click="goHome">{{$t('m.goBack')}}</div>
      <!-- bondo充值成功后的提示：前往App Store下载Bondo, 并在APP与官网使用同一账号登录。登录完成后，官网充值的余额可在APP内直接用于解锁付费短剧剧集-->
      <div class="bondo-pay-success-tip">
        {{$t('m.bondo_pay_success_tip')}}
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { Toast } from 'vant';
Vue.use(Toast);
  export default {
    name: 'success',
    data() {
      return {

      }
    },
    watch: {

    },
    filters: {

    },
    mounted() {
       this.getLang();
       Toast.clear();
    },
    methods: {
      getLang() {
        var box = document.getElementById("app");
        let language = navigator.language || navigator.browserLanguage;
        if (language == 'ar') {
          box.style.direction = 'rtl';
        }else{
          box.style.direction = 'ltr';
        }
      },
      goHome(){
      	this.$router.push({
      	  path: '/'
      	})
      }

    },

  }
</script>

<style scoped>
.success-btn{
  padding: .23rem 0 !important;
  width: 66% !important;
}
.bondo-pay-success-tip {
  width: 66%;
  padding: 0.16rem 0;
  margin: 0 auto;
  color: #9497A2;
  font-size: 0.24rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/pages/success.vue